import axios from 'axios';
import { gameData, networkData } from './data';
import { URL } from './constants';

const api = axios.create({
    // baseURL: 'http://3.211.81.248:8004/api/v1/',
    baseURL: URL.BASE,
    timeout: 5000, 
})

class GameService {
    static async getOperatorUserToken(credentials) {
        try {
                const response = await axios.post(`http://3.211.81.248:8006/api/v1/auth/login`, credentials)
              //  console.log("get operator user token" , response.data)
                return response.data
            } catch (error) {
                errorHandling(`Error getting operator user token: ${error}`)
                throw error
            }
        }

    static async getAccessToken(credentials) {
        try {
            if (networkData.response) {                
                return networkData.response
            }
            // } else{
            //     const response = await api.post('/user/login', credentials)
            // //   console.log("get getAccessToken" , response.data)
            //     return response.data
            // }
        } catch (error) {
            errorHandling(`Error getting access token: ${error}`)
            throw error
        }
    }

    static async buyTickets(ticketData) {
        try {
            const response = await api.post('/game/lottery/cash-cash/buy-tickets', ticketData)
            return response.data
        } catch (error) {
            errorHandling(`Error buying tickets: ${error}`)
            throw error
        }
    }


    static async placeBet(betData) {
        try {
            const response = await api.post('/game/lottery/cash-cash/play-game', betData)
            return response.data
        } catch (error) {
            errorHandling(`Error placing bet: ${error}`)
            throw error
        }
    }

    static async scratchScore(scoreData) {
        try {
            const response = await api.post('/game/lottery/cash-cash/scratch-score', scoreData)
            return response.data
        } catch (error) {
            errorHandling(`Error scratching score: ${error}`)
            throw error
        }
    }

    static async turboMode(){
        try{
            const response = await api.post('/game/lottery/cash-cash/scratch-score-turbo');
            return response.data
        } catch(error){
            errorHandling(`Error turbo mode: ${error}`);
            throw error
        }
    }

    static async history(){
        try {
            const response = await api.get(`/user/bet-history?page=1&perPage=10&gameId=${networkData.gameId}`);
            return response.data
        } catch(error){
            errorHandling(`Error bet history: ${error}`);
            throw error
        }
    }

    static async myBets(userId) {
        try {
            const response = await api.get(`/game/lottery/cash-cash/my-bets?page=1&perPage=2&filter=lost?userId=${userId}`)
            return response.data
        } catch (error) {
            errorHandling(`Error fetching my bets: ${error}`)
            throw error
        }
    }

    static async getLastPendingBet() {
        try {
            const response = await api.get(`/game/lottery/cash-cash/get-pending-bet`)
            return response.data
        } catch (error) {
            errorHandling(`Error fetching my last pending bets: ${error}`)
            throw error
        }
    }

    static async setLanguage(lang = "en") {

        gameData.gameLanguage = lang
    
        const data = {
            "language": lang
        }
        try {
            const response = await api.post('/user/update-language-status', data);
    
    
        } catch (error) {
        }
    }

    static authorize() {
        console.log("gergregre", networkData.jwtToken);
        
        if (networkData?.jwtToken) 
            api.defaults.headers['Authorization'] = `Bearer ${networkData.jwtToken}`;
        else {
            errorHandling('JWT token is not available')
        }
    }
    
}

const errorHandling = (error) =>{
    if (error?.code === 'ECONNABORTED') {
   
    }

    if(error === 'JWT token is not available'){
    }

}

export default GameService;
